import axios from 'utils/axios'
import { VERSIONS } from 'utils/version'

export const GetBySistemaId = (sistemaId, params) => axios.get(`${VERSIONS.V1}/blacklist/GetBySistemaId/${sistemaId}`, { params })
  